import { isIsoDate, isoToDateLocal } from '@go-shared/lib/time';
import React from 'react';

import './DefaultedText.scss';

interface DefaultedTextPropsBase {
  val: string | undefined;
  html?: boolean;
  block?: boolean;
  def?: string;
}

type DefaultedTextProps = DefaultedTextPropsBase & React.HTMLAttributes<HTMLElement>;

export function DefaultedText(props: DefaultedTextProps) {
  const { val, block, html, def, ...rest } = props;

  let valToUse = val;

  if (isIsoDate(val || '')) {
    valToUse = isoToDateLocal(val!).toLocaleDateString();
  }

  if (!valToUse || valToUse.length === 0) {
    return (
      <span className="text-smoke italic" {...rest}>
        {def || 'None'}
      </span>
    );
  }

  if (block) {
    if (html) {
      return (
        <div
          className="defaulted-text"
          dangerouslySetInnerHTML={{ __html: valToUse }}
          {...rest}
        ></div>
      );
    } else {
      return <div {...rest}>{valToUse}</div>;
    }
  }

  if (html) {
    return (
      <span
        className="defaulted-text"
        dangerouslySetInnerHTML={{ __html: valToUse }}
        {...rest}
      ></span>
    );
  }

  return <span {...rest}>{valToUse}</span>;
}
